<template>
    <a :href="`${base[type]}${href}`" class="social">
        <div :class="`social-icon ${type}`"></div>
    </a>
</template>
<script>
export default {
    name : "SocialComponent",
    data(){
        return {
            base : {
                "Telegram" : "https://t.me/",
                "Instagram" : "https://instagram.com/",
                "X" : "https://x.com/",
                "VK" : "https://vk.com/",
                "MAX" : "",
                "YT" : "",
                "Twitch" : "",
            }
        }
    },
    props : {
        type : {
            type : String
        },
        href : {
            type : String
        }
    }
}
</script>